import { keepPreviousData, useQuery } from '@tanstack/react-query';
import {
  fetchSpendAggregation,
  spendAggregationQueryKey,
  type SpendAggregationQuery,
} from '@/features/transactions/spendAggregation';

export type { SpendAggregationQuery } from '@/features/transactions/spendAggregation';
export { spendAggregationQueryKey } from '@/features/transactions/spendAggregation';

export interface UseSpendByMerchantParams {
  accountIds?: readonly string[];
  dateFrom?: string;
  dateTo?: string;
  cursor?: string | null;
  enabled?: boolean;
}

export function useSpendByMerchant(params: UseSpendByMerchantParams = {}) {
  const query: SpendAggregationQuery = {
    mode: 'merchant',
    accountIds: params.accountIds ?? [],
    dateFrom: params.dateFrom,
    dateTo: params.dateTo,
    cursor: params.cursor,
  };

  return useQuery({
    queryKey: spendAggregationQueryKey(query),
    enabled: params.enabled ?? true,
    retry: false,
    placeholderData: keepPreviousData,
    queryFn: () => fetchSpendAggregation(query),
  });
}

export default useSpendByMerchant;
